import { getData } from "./axiosConfig"

const token = localStorage.getItem("access_token")

export const getBooks = async (bookType) => {
    let url
    if (token) {
        url = `user/books?book_type=${bookType}`
    } else {
        url = `books?book_type=${bookType}`
    }
    return await getData(url)
}

export const getTrendingBooks = async () => {
    let url
    if (token) {
        url = `user/trending-books`
    } else {
        url = `trending-books`
    }

    return await getData(url)
}

export const getReadBook = async (bookId, chapterId) => {
    let url
    if (token) {
        url = `/user/read-book/${bookId}/${chapterId}`
    } else {
        url = `/read-book/${bookId}/${chapterId}`
    }

    return await getData(url)
}
export const getBookReadChapter = async (bookId, chapterId) => {
    let url
    if (token) {
        url = `/user/book/read-chapters/${bookId}/${chapterId}`
    } else {
        url = `/book/read-chapters/${bookId}/${chapterId}`
    }

    return await getData(url)
}

export const getBookProgress = async (bookId) => {
    let url
    if (token) {

        url = `/user/book-detail/bookid/${bookId}`
    } else {
        url = `/book-detail/bookid/${bookId}`
    }

    return await getData(url)
}